/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Tag_CommunicationInputs */

const en_resume_tag_communication = /** @type {(inputs: Resume_Tag_CommunicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Communication`)
};

const ar_resume_tag_communication = /** @type {(inputs: Resume_Tag_CommunicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التواصل`)
};

const bn_resume_tag_communication = /** @type {(inputs: Resume_Tag_CommunicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`যোগাযোগ`)
};

const de_resume_tag_communication = /** @type {(inputs: Resume_Tag_CommunicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommunikation`)
};

const es_resume_tag_communication = /** @type {(inputs: Resume_Tag_CommunicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunicación`)
};

const fr_resume_tag_communication = /** @type {(inputs: Resume_Tag_CommunicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Communication`)
};

const pt_resume_tag_communication = /** @type {(inputs: Resume_Tag_CommunicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunicação`)
};

const zh_resume_tag_communication = /** @type {(inputs: Resume_Tag_CommunicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通讯`)
};

const tr_resume_tag_communication = /** @type {(inputs: Resume_Tag_CommunicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İletişim`)
};

const ru_resume_tag_communication = /** @type {(inputs: Resume_Tag_CommunicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общение`)
};

const pl_resume_tag_communication = /** @type {(inputs: Resume_Tag_CommunicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komunikacja`)
};

/**
* | output |
* | --- |
* | "Communication" |
*
* @param {Resume_Tag_CommunicationInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_tag_communication = /** @type {((inputs?: Resume_Tag_CommunicationInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Tag_CommunicationInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_tag_communication(inputs)
	if (locale === "bn") return bn_resume_tag_communication(inputs)
	if (locale === "de") return de_resume_tag_communication(inputs)
	if (locale === "es") return es_resume_tag_communication(inputs)
	if (locale === "fr") return fr_resume_tag_communication(inputs)
	if (locale === "pt") return pt_resume_tag_communication(inputs)
	if (locale === "zh") return zh_resume_tag_communication(inputs)
	if (locale === "tr") return tr_resume_tag_communication(inputs)
	if (locale === "ru") return ru_resume_tag_communication(inputs)
	if (locale === "pl") return pl_resume_tag_communication(inputs)
	return en_resume_tag_communication(inputs)
});